import { LitElement, css, html } from 'lit';
import { customElement, property } from 'lit/decorators';

enum ModalSize {
    sm = 'sm',
    md= 'md',
    lg = 'lg',
    xl = 'xl',
}

@customElement('modal-dialog')
export class ModalDialog extends LitElement {
    @property({ type: String })
    size: ModalSize = ModalSize.lg;

    @property({ type: Boolean })
    hideCloseButton: boolean = false;

    async handleClose() {
        this.dispatchEvent(new CustomEvent('close'));
    }

    protected render() {
        return html`
            <div id="modalDialog" class="modal-${this.size}">
                <div id="modalContent">
                    ${this.hideCloseButton ? '' : html`
                        <button class="modalCloseButton" @click="${this.handleClose}"></button>
                    `}
                    <slot name="header"></slot>
                    <slot name="body" id="modalBody"></slot>
                </div>
            </div>
        `;
    }

    static get styles() {
        return css`
            #modalDialog {
                position: relative;
                width: auto;
                pointer-events: none;
                display: flex;
                align-items: center;
                min-height: calc(100% - 1rem);
                margin-right: auto;
                margin-left: auto;
                margin-top: 0;
                margin-bottom: 0;
            }

            #modalContent {
                position: relative;
                display: flex;
                flex-direction: column;
                width: 100%;
                pointer-events: auto;
                background-color: var(--theme-white-color);
                background-clip: padding-box;
                border-radius: 0.75rem;
                outline: 0;
                border: 0;
                box-shadow: none;
            }

            #modalBody {
                position: relative;
                flex: 1 1 auto;
            }

            .modalCloseButton {
                box-sizing: content-box;
                width: 0.75em;
                height: 0.75em;
                padding: 0.25em 0.25em;
                color: var(--main-primary-color);
                background: transparent
                    url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23000'%3e%3cpath d='M.293.293a1 1 0 011.414 0L8 6.586 14.293.293a1 1 0 111.414 1.414L9.414 8l6.293 6.293a1 1 0 01-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 01-1.414-1.414L6.586 8 .293 1.707a1 1 0 010-1.414z'/%3e%3c/svg%3e")
                    center/0.75em auto no-repeat;
                border: 0;
                border-radius: 0.5rem;
                opacity: 0.5;
                z-index: 10;
                position: absolute;
                top: -5px;
                right: 0px;
                font-size: 1.25rem;
                cursor: pointer;
            }

            .modalCloseButton:hover {
                opacity: 0.75;
            }

            #modalDialog.modal-sm {
                max-width: 300px;
            }

            #modalDialog.modal-md {
                max-width: 500px;
            }

            #modalDialog.modal-lg {
                max-width: 70vw;
            }

            #modalDialog.modal-xl {
                min-width: 80vw;
                min-height: 80vh;
            }

            @media (min-width: 550px) {
                #modalDialog.modal-md {
                    max-width: 550px;
                }

                #modalDialog.modal-xl {
                    min-width: 80vw;
                    min-height: 80vh;
                }
            }
        `;
    }
}
